import { updateConsultRequestFields, updateQualificationResponses } from '../../services/customFieldService';
import { t } from '../../utils/i18n';
import {
    appUrl,
    form,
    leadTextId,
    listDataQuestion,
    listNamePageQuestion,
    nameScreenDynamic,
    progressQuestion,
    setListDataQuestion,
    setListNamePageQuestion,
    setNameScreenDynamic,
    setProgressQuestion,
    questionnaireFields,
    questionnaireFormId,
    clearQuestionnaireContext,
} from '../../utils/variables';
import { toastError } from '../../views/components/error';
import { clearCustomFields, loadCustomFields } from '../actions/consultActions';
import { dateQuestionListener } from './dateQuestionListener';
import { heightQuestionListener } from './heightQuestionListener';
import { customFeildGoBackAnimationHandler, navigate, setSessionEndStepSentForLeadId, setIsDisqualified } from './movePages';
import { numberQuestionListener } from './numberQuestionListener';
import { selectQuestionListener } from './selectQuestionListener';
import { textAreaQuestonListener } from './textareaQuestionListener';
import { textQuestionListener } from './textQuestionListener';
import { navigateToNextPage } from './navigationHelper';
import { evaluateDisqualifier, shouldDisqualifyNow } from '../../utils/disqualifierEvaluator';
import { navigate } from './movePages';
import { SCREEN } from '../../utils/constants';
import { updateLeadStep } from '../../services/leadServices';
import { leadInfo } from '../../utils/variables';

export function checkboxQuestionListener() {
    const fieldId = nameScreenDynamic.split('--')[1];
    const previousAnswer = listDataQuestion[fieldId];

    var radios = document.querySelectorAll(`${nameScreenDynamic} #checkbox`);
    let val = '';

    // If the user previously answered this question (yes=1 or no=0), pre-check
    // the matching radio and seed `val` from the stored answer. Without this,
    // navigating Back → Forward re-renders the radios in an unselected state
    // while leaving the Continue button enabled; clicking Continue without
    // re-selecting silently overwrote the answer with 0 ("No") because `val`
    // was '' and `storedVal = val === 'yes' ? 1 : 0` defaults to 0.
    // Use `!== undefined` so a stored 0 ("No") also restores correctly.
    if (previousAnswer !== undefined) {
        const yesRadio = document.querySelector(
            `${nameScreenDynamic} #checkbox[value="yes"]`
        );
        const noRadio = document.querySelector(
            `${nameScreenDynamic} #checkbox[value="no"]`
        );
        if (previousAnswer === 1 && yesRadio) {
            yesRadio.checked = true;
            val = 'yes';
        } else if (previousAnswer === 0 && noRadio) {
            noRadio.checked = true;
            val = 'no';
        }
        if (val !== '') {
            document
                .querySelector(`${nameScreenDynamic} .checkboxContinue__btn`)
                ?.classList.remove('disabled');
            document
                .querySelector(
                    `${nameScreenDynamic} .checkboxContinue__btn .loading__wrapper`
                )
                ?.classList.add('hidden');
            const loaderIcon = document.querySelector(
                `${nameScreenDynamic} .loader__icon`
            );
            if (loaderIcon) {
                loaderIcon.innerHTML = '';
                loaderIcon.insertAdjacentHTML(
                    'beforeend',
                    `<i class="ri-arrow-right-line"></i>`
                );
            }
        }
    }

    for (var i = 0, max = radios.length; i < max; i++) {
        radios[i].onclick = function () {
            if (this.value) {
                val = this.value;
                document
                    .querySelector(
                        `${nameScreenDynamic} .checkboxContinue__btn`
                    )
                    .classList.remove('disabled');
            } else {
                val = this.value;
                document
                    .querySelector(
                        `${nameScreenDynamic} .checkboxContinue__btn`
                    )
                    .classList.add('disabled');
            }
        };
    }

    /* On click Back button */
    document
        .querySelector(`${nameScreenDynamic} .checkboxQuestionBack__btn`)
        ?.addEventListener('click', () => {
            const idx = listNamePageQuestion.findIndex(
                (l) => l === nameScreenDynamic
            );
            if (idx > 0) {
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
                setProgressQuestion({
                    ...progressQuestion,
                    currentQuestion: progressQuestion.currentQuestion - 1,
                    progress: (((progressQuestion.currentQuestion - 1) / progressQuestion.total) * 100)
                });
                setNameScreenDynamic(listNamePageQuestion[idx - 1]);

                if (
                    nameScreenDynamic.includes('text') &&
                    !nameScreenDynamic.includes('textarea')
                ) {
                    textQuestionListener();
                } else if (nameScreenDynamic.includes('checkbox')) {
                    checkboxQuestionListener();
                } else if (nameScreenDynamic.includes('select')) {
                    selectQuestionListener();
                } else if (nameScreenDynamic.includes('date')) {
                    dateQuestionListener();
                } else if (nameScreenDynamic.includes('textarea')) {
                    textAreaQuestonListener();
                } else if (nameScreenDynamic.includes('number')) {
                    numberQuestionListener();
                } else if (nameScreenDynamic.includes('height')) {
                    heightQuestionListener();
                }
            } else {
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
            }
        });

    /* On click enter */
    const screenCheckbox = document.querySelector(
        `${nameScreenDynamic} .screen--checkbox`
    );

    if (screenCheckbox) {
        screenCheckbox.addEventListener('keydown', (event) => {
            if (
                event.key === 'Enter' &&
                !document
                    .querySelector(
                        `${nameScreenDynamic} .checkboxContinue__btn`
                    )
                    .classList.contains('disabled')
            ) {
                document
                    .querySelector(
                        `${nameScreenDynamic} .checkboxContinue__btn`
                    )
                    .click();
            }
        });
    }

    // on click continue button
    const buttonCheckboxContinue = document.querySelector(
        `${nameScreenDynamic} .checkboxContinue__btn`
    );
    buttonCheckboxContinue.addEventListener('click', async function () {
        if (!listNamePageQuestion.find((list) => list === nameScreenDynamic)) {
            listNamePageQuestion.push(nameScreenDynamic);
        }
        setListNamePageQuestion(listNamePageQuestion);
        document
            .querySelector(`${nameScreenDynamic} .checkboxContinue__btn`)
            .classList.add('disabled');
        document
            .querySelector(
                `${nameScreenDynamic} .checkboxContinue__btn .loading__wrapper`
            )
            ?.classList.remove('hidden');
        const loaderIcon = document.querySelector(
            `${nameScreenDynamic} .loader__icon`
        );
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML(
                'beforeend',
                `<img src="${appUrl}/assets/icons/rolling.png" />`
            );
        }
        const item = nameScreenDynamic.split('--')[1];
        const storedVal = val === 'yes' ? 1 : 0;
        const answersWithCurrent = { ...listDataQuestion, [item]: storedVal };
        listDataQuestion[item] = storedVal;
        setListDataQuestion(listDataQuestion);
        const fields = questionnaireFields?.length
            ? questionnaireFields
            : form?.form?.custom_fields ?? [];
        const currentField = fields.find((f) => f && f.id == item);
        const minDisqualifiers = form?.appointment_channel?.min_disqualifier_matches ?? form?.consult_min_disqualifier_matches ?? 1;
        if (currentField && evaluateDisqualifier(currentField, storedVal) && shouldDisqualifyNow(fields, answersWithCurrent, minDisqualifiers)) {
            try {
                const fieldLabels = {};
                const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || t('custom_field')); });
                const formId = questionnaireFormId ?? form?.form?.id;
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                } else {
                    await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                }
            } catch (_) { /* save best-effort */ }
            if (leadInfo?.id) {
                await updateLeadStep(leadInfo.id, 'disqualified', 'true');
                setSessionEndStepSentForLeadId(leadInfo.id);
            }
            document.querySelector(`${nameScreenDynamic} .checkboxContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${nameScreenDynamic} .checkboxContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${nameScreenDynamic} .checkboxContinue__btn .loader__icon`);
            if (loaderIcon) { loaderIcon.innerHTML = ''; loaderIcon.insertAdjacentHTML('beforeend', '<i class="ri-arrow-right-line"></i>'); }
            clearCustomFields();
            clearQuestionnaireContext();
            setIsDisqualified(true);
            navigate(SCREEN.THE_END);
            return;
        }
        const formId = questionnaireFormId ?? form?.form?.id;
        let idx = fields.findIndex(
            (custom) => custom && custom.id == nameScreenDynamic.split('--')[1]
        );
        if (idx == fields.length - 1) {
            try {
                const fieldLabels = {};
                const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || t('custom_field')); });
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                } else {
                    await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                }
                if (
                    document.querySelector(
                        `${nameScreenDynamic} .checkboxContinue__btn`
                    )
                ) {
                    document
                        .querySelector(
                            `${nameScreenDynamic} .checkboxContinue__btn`
                        )
                        ?.classList.remove('disabled');
                }
                document
                    .querySelector(
                        `${nameScreenDynamic} .checkboxContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                clearCustomFields();
                clearQuestionnaireContext();
                navigateToNextPage();
            } catch (error) {
                toastError(error.response?.data?.message);
            }
        } else {
            setProgressQuestion({
                ...progressQuestion,
                currentQuestion: progressQuestion.currentQuestion + 1,
                progress: (((progressQuestion.currentQuestion + 1) / progressQuestion.total) * 100)
            });
            loadCustomFields(fields[idx + 1]);
        }
    });
}